// extracted by mini-css-extract-plugin
export var autoExpand = "_1j-8";
export var container = "_1j-7";
export var containerWidth = "_1j-5";
export var disabled = "_1j-2";
export var error = "_1j-3";
export var fullWidth = "_1j-6";
export var inputWrapper = "_1j-0";
export var small = "_1j-1";
export var textarea = "_1j-4";